import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Route } from '../models/enums/Route.enum';
import { Price } from '../models/types/Product/Price.type';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(
    private readonly router: Router
  ) { }

  getPriceLabel(price: Price | null | undefined) {
    if (price) {
      return this.getFormattedPrice(price.price, price.currency);
    } else {
      return '';
    }
  }

  getFormattedPrice(price: number | null, currency?: string | null): string {
    let priceLabel = "";
    if (price) {
      //Conversione SEMPRE nel formato italiano
      priceLabel += price.toLocaleString("it-IT");
    }

    if (currency) {
      priceLabel += ` ${currency}`;
    }
    return priceLabel;
  }

  navigateTo_HomePage() {
    this.router.navigate([Route.HomePage])
  }

  navigateTo_MainPage() {
    this.router.navigate([Route.Main]);
  }

  navigateTo_SetStorePage() {
    this.router.navigate([Route.SetStorePage]);
  }

  navigateTo_ErrorPage(cb?: Function) {
    cb && cb();
    this.router.navigate([Route.ErrorPage]);
  }

  navigateTo_ProductPage(sapCode: string, openInNewTab: boolean = false) {
    const url = `/${Route.Main}/${Route.Product}/${sapCode}`;
    if (openInNewTab) {
      window.open(url, '_blank', 'noopener,noreferrer');
    } else {
      this.router.navigateByUrl(url);
    }
  }

  navigateTo_PdfPage(pdfUrl: string) {
    const url = `${window.location.origin}/${Route.PdfPage}?attachment=${encodeURIComponent(pdfUrl)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  getUrl_PrivacyPolicyPage() {
    return `/${Route.Main}/${Route.PrivacyPolicy}`;
  }

  getUrl_TermsAndConditionsPage() {
    return `/${Route.Main}/${Route.TermsAndConditions}`;
  }

}
